<template lang="html">

  <!-- Не трогай я еще доделаю -->
  <!-- TODO Разбить на компоненты -->

  <div
    class="sidebar"
    id="sidebar"
    :class="{
      minimized: minimized,
      active: active,
    }"
  >
    <DigifarmLogo v-if="$whitelabel === 'digifarm'"/>
    <SidebarLogo v-else/>

    <nav class="main-menu">
      <div class="scroller">

        <!-- <template> -->

          <router-link class="menu-item" to="/dashboard/farms/map-view">
            <div class="icon-container">
              <farm-map-icon />
            </div>
            <div class="text">{{ $ml.get(`Farm map`) }}</div>
          </router-link>

          <!-- <TutArrow/> -->

          <router-link class="menu-item" to="/dashboard/tests">
            <div class="icon-container">
              <field-tests-icon />
            </div>
            <div class="text">{{ $ml.get(`Field tests`) }}</div>
          </router-link>

          <!-- <TutArrow/> -->

          <router-link class="menu-item" to="/dashboard/programs/list/0">
            <div class="icon-container">
              <programs-icon />
            </div>
            <div class="text">{{ $ml.get(`Programs`) }}</div>
          </router-link>

          <app-devider/>

          <router-link class="menu-item" to="/dashboard/my-reports">
            <div class="icon-container">
              <reports-icon />
            </div>
            <div class="text">{{ $ml.get('My reports') }}</div>
          </router-link>

          <router-link class="menu-item" to="/dashboard/crops">
            <div class="icon-container">
              <crops-icon />
            </div>
            <div class="text">{{ $ml.get(`Crops`) }}</div>
          </router-link>

          <router-link class="menu-item" to="/dashboard/fertilizers/all/0/">
            <div class="icon-container">
              <fertilizers-icon />
            </div>
            <div class="text">{{ $ml.get(`Fertilizers`) }}</div>
          </router-link>

          <router-link class="menu-item" to="/dashboard/labs">
            <div class="icon-container">
              <labs-icon />
            </div>
            <div class="text">{{ $ml.get(`Labs`) }}</div>
          </router-link>



          <router-link
            class="menu-item"
            to="/dashboard/satellite/active"
            v-if="$whitelabel !== 'digifarm' && $store.getters['user/data'].globalRole == 'admin'"
          >
            <div class="icon-container">
              <satellite-icon />
            </div>
            <div class="text">{{$ml.get('Satellite')}}</div>
          </router-link>


          <router-link
            class="menu-item"
            to="/dashboard/drainage"
          >
            <div class="icon-container">
              <img style="width: 28px;" src="./layer.png"/>
            </div>
            <div class="text">{{$ml.get('Drainage')}}</div>
          </router-link>


          <template v-if="$whitelabel !== 'digifarm' && user.connectsTo == '0' && (user.subsPlan == 'elite' || user.subsPlan == 'premium')">
            <router-link class="menu-item" to="/dashboard/sub-accounts">
              <div class="icon-container">
                <accounts-icon />
              </div>
              <div class="text">{{$ml.get('Sub Accounts')}}</div>
            </router-link>
          </template>

          <app-devider/>

          <router-link 
            class="menu-item" 
            to="/dashboard/market/catalog"
            v-if="$store.getters['user/data'].globalRole == 'admin'">
            <div class="icon-container">
              <education-icon />
            </div>
            <div class="text" :class="{notice: !isViewed}">{{ $ml.get(`Education`) }}</div>
          </router-link>

          <router-link class="menu-item" to="/dashboard/support">
            <div class="icon-container">
              <support-icon />
            </div>
            <div class="text" :class="{notice: !isViewed}">{{ $ml.get(`Support`) }}</div>
          </router-link>
        <!-- </template> -->

        <template v-if="!user.subsPlan">
          <router-link class="menu-item plan" to="/dashboard/plans">
            <div class="icon-container">
              <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M-1.96701e-07 5L0 9.5L7 4.5L14 9.5L14 5L7 -3.0598e-07L-1.96701e-07 5Z" fill="white"/>
                <path d="M-1.96701e-07 12L0 16.5L7 11.5L14 16.5L14 12L7 7L-1.96701e-07 12Z" fill="white"/>
              </svg>
            </div>
            <div class="text">{{ $ml.get(`UPGRADE`) }}</div>
          </router-link>
        </template>

        <!-- <div class="spacer"></div> -->

        <router-link class="menu-item" to="/dashboard/account">
          <div class="icon-container">
            <my-account-icon />
          </div>
          <div class="text">{{ $ml.get(`My account`) }}</div>
        </router-link>

        <!-- <div class="bot-fix"> -->
          <button class="menu-item" @click="toggle">
            <div class="icon-container">
              <collapse-icon/>
            </div>
            <div class="text">{{ $ml.get(`Minimize`) }}</div>
          </button>
        <!-- </div> -->

      </div>
    </nav>

  </div>
</template>

<script>
import CropsIcon from './icons/CropsIcon'
import MyAccountIcon from './icons/MyAccountIcon'
import FertilizersIcon from './icons/FertilizersIcon'
import AccountsIcon from './icons/AccountsIcon'
import ProgramsIcon from './icons/ProgramsIcon'
import FarmMapIcon from './icons/FarmMapIcon'
import LabsIcon from './icons/LabsIcon'
import SatelliteIcon from './icons/SatelliteIcon'
import SupportIcon from './icons/SupportIcon'
import FieldTestsIcon from './icons/FieldTestsIcon'
import ReportsIcon from './icons/ReportsIcon'
import SidebarLogo from './SidebarLogo'
import CollapseIcon from './icons/CollapseIcon'
import TutArrow from './TutArrow'
import DigifarmLogo from './DigifarmLogo'
import { mapGetters } from 'vuex'
import EducationIcon from "@/components/common/sidebar/icons/EducationIcon";

export default {
  data() {
    return {

    }
  },
  watch: {
    $route(to, from) {
      this.deactivate();
    }
  },
  created () {
    this.$store.dispatch('isViewed');
  },
  methods: {


    logout() {
      this.$store.commit('user/logout');
      this.$router.push('/');
    },


    toggle() {
      this.$store.dispatch('sidebar/toggleMinimize');
    },


    deactivate() {
      this.$store.dispatch('sidebar/deactivate');
    },
  },
  components : {
    CropsIcon,
    MyAccountIcon,
    FertilizersIcon,
    ProgramsIcon,
    FarmMapIcon,
    FieldTestsIcon,
    SidebarLogo,
    LabsIcon,
    CollapseIcon,
    TutArrow,
    EducationIcon,
    SupportIcon,
    ReportsIcon,
    AccountsIcon,
    SatelliteIcon,
    DigifarmLogo,
  },
  computed: {
    ...mapGetters({
      user: 'user/data',
      minimized: 'sidebar/minimized',
      active: 'sidebar/active',
      isViewed: 'getViewed'
    }),
  },
}
</script>

<style lang="scss" scoped>

.notice::before {
  content: '';
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: orange;
  position: absolute;
  left: 110%;
  top: 5px;
}

.sidebar {
  top: 0;
  right: 0;
  z-index: 50;
  left: 0;
  top: 0;
  min-height: calc(100% - 40px);
  width: 240px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background: #fff;
  transition:
    width .3s ease,
    transform .3s ease,
    padding .3s ease;
  // max-height: 100vh;
  // padding-bottom: 80px;
  border-right: 1px #E4E5E6 solid;
  position: fixed;
  height: calc(100% - 40px);

  .collapse {
    background-color: #fff;
    border-width: 0;
    outline: none;
    padding: 4px 0;
    cursor: pointer;
    background-color: #e5e5e5;
  }

  .main-menu {

    padding-top: 0;
    overflow-y: auto;
    overflow-x: hidden;
    // padding-bottom: 50px;
    flex-grow: 1;
    // border-top: 1px solid #E4E5E6;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;

    .bot-fix {

      // position: absolute;
      bottom: 0;
      // width: 100%;
      left: 0;
      background: #fff;
      height: 60px;
      padding: 0px 0;
      transition: padding 0.3s ease;

      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

    }

    .spacer {
      // flex-grow: 1;
    }

    .scroller {
      padding: 0;
      transition: padding .3s ease;
      min-height: 100%;
      flex-grow: 1;

      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
    }

    .app-devider {
      margin: 2px 0;
    }

    .menu-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0;
      background: transparent;
      border: 0;
      cursor: pointer;
      font-size: 14px;
      color: #333333;
      text-decoration: none;
      font-weight: 500;
      height: 55px;
      margin-bottom: 0px;
      transition: .3s ease;
      position: relative;
      margin-left: 15px;
      // border-bottom: 1px solid #E4E5E6
      &:nth-child(odd) {
        // background-color: #F9F9F9;
      }
      &.plan {
        background: $mainGreen;
        border-radius: 5px 0 0 5px;
        color: #fff;

        &:hover,
        &.router-link-active {
          .text {
            color: #fff;
          }
          .icon-container {
            svg {
              fill: #fff;
            }
          }
        }
      }

      &.main {
        margin-bottom: 0;
      }

      .text {
        transition: transform .3s ease;
        transform-origin: 0 50%;
        white-space: nowrap;
        position: absolute;
        left: calc(10px + 32px + 16px);
      }

      .icon-container {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        padding: 0;
        transition: background .3s ease;

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        svg {
          width: 28px;
          height: 28px;
          fill: #333;
        }
      }
      &:hover,
      &.router-link-active {

        .text {
          color: $mainGreen;
        }

        .icon-container {
          svg {
            fill: $mainGreen;
          }
        }

      }

      &:last-child {
        // margin: 0;
      }
    }
  }


  // MINIMIZED -----------------


  &.minimized {

    width: 81px;

    .main-menu {

      flex-grow: 1;

      .bot-fix {
        padding: 0px 0;

        @media (max-width: 1100px) {
          display: none;
        }
      }

      .scroller {
        padding: 0;
      }

      .menu-item {
        .text {
          transform: scale(0);
        }

        &.plan {
          &:hover,
          &.router-link-active {
            .icon-container {
              background-color: transparent;
            }
          }
        }

        &:hover,
        &.router-link-active {
          .icon-container {
            background-color: $mainGreen;
            svg {
              fill: #fff;
              transition: fill 0.3s ease;
            }
          }
        }
      }
    }
  }

  @media (max-width: 1100px) {
    transform: translateX(-100%);
    z-index: 9999;
    min-height: 100%;
    &.active {
      transform: translateX(0);
      box-shadow: 0 0 20px rgba($color: #000000, $alpha: 0.2);
    }
  }
  @media (max-width:768px) {
    padding-bottom: 0;
    .main-menu {
      // padding-top: 16px;
      .bot-fix, .tut-arrow {
        display: none;
      }
      .app-devider {
        margin: 8px 0;
      }
    }
  }
}
body[dir="rtl"] {
  .sidebar {
    .main-menu {
      .menu-item {
        .text {
          left: unset;
          right: calc(10px + 32px + 16px);
        }
      }
    }
    @media(max-width:1100px) {
      left: unset;
      // right: unset;
      transform: translateX(100%);
      &.active {
        transform: translateX(0);
        box-shadow: 0 0 20px rgba($color: #000000, $alpha: 0.2);
      }
    }
  }
}
</style>
